// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.media-system {
  position: relative;
  color: var(--color-text);
  background:
    radial-gradient(circle at top right, rgba(116, 187, 80, 0.12), transparent 28rem),
    var(--color-surface);
  border: 1px solid var(--color-border-soft);
  border-radius: 18px;
  box-shadow: 0 18px 50px rgba(29, 46, 35, 0.08);
  overflow: hidden;
}

.media-system .sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.media-system-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 2rem;
  padding: 1.6rem 1.8rem 1.3rem;
  border-bottom: 1px solid var(--color-border-soft);
}

.media-system .media-system-header h2 {
  margin: 0.15rem 0 0.35rem;
  font-size: clamp(1.55rem, 2.5vw, 2.2rem);
  line-height: 1.1;
}

.media-system-header p {
  margin: 0;
  color: color-mix(in srgb, var(--color-text) 68%, transparent);
}

.media-system-eyebrow {
  display: block;
  color: var(--color-accent);
  font-size: 0.74rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.media-system-header-actions,
.media-system-detail-actions,
.media-system-details-footer {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
}

.media-system-header-actions .button,
.media-system-detail-actions .button,
.media-system-details-footer .button,
.media-system-card-actions .button {
  border-radius: 8px;
}

.media-system-header-actions .button i {
  margin-right: 0.45rem;
}

.media-system-upload {
  padding: 1.2rem 1.8rem;
  background: var(--color-surface-soft);
  border-bottom: 1px solid var(--color-border-soft);
}

.media-system-dropzone {
  display: grid;
  justify-items: center;
  gap: 0.45rem;
  padding: 1.6rem;
  text-align: center;
  border: 2px dashed var(--color-border);
  border-radius: 14px;
  transition: 160ms ease;
}

.media-system-dropzone.is-dragging {
  border-color: var(--color-accent);
  background: color-mix(in srgb, var(--color-accent) 10%, var(--color-surface));
  transform: translateY(-2px);
}

.media-system-dropzone > i {
  color: var(--color-accent);
  font-size: 2rem;
}

.media-system-dropzone > span {
  font-size: 0.85rem;
  color: color-mix(in srgb, var(--color-text) 65%, transparent);
}

.media-system-dropzone input {
  width: min(100%, 420px);
  margin-top: 0.5rem;
}

.media-system-upload-progress {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0.35rem 1rem;
  align-items: center;
  margin-top: 1rem;
}

.media-system-upload-progress span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.media-system-upload-progress progress {
  grid-column: 1 / -1;
  width: 100%;
}

.media-system-toolbar {
  display: grid;
  grid-template-columns: minmax(240px, 1fr) minmax(150px, 210px) auto;
  gap: 0.8rem;
  align-items: center;
  padding: 1rem 1.8rem;
}

.media-system-toolbar input,
.media-system-toolbar select {
  width: 100%;
  min-height: 42px;
  padding: 0.65rem 0.75rem;
  color: var(--color-text);
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 9px;
  font: inherit;
}

.media-system-search {
  position: relative;
}

.media-system-search i {
  position: absolute;
  top: 50%;
  left: 0.8rem;
  color: color-mix(in srgb, var(--color-text) 48%, transparent);
  transform: translateY(-50%);
}

.media-system-search input {
  padding-left: 2.25rem;
}

.media-system-count {
  color: color-mix(in srgb, var(--color-text) 62%, transparent);
  font-size: 0.85rem;
  white-space: nowrap;
}

.media-system-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 1rem;
  padding: 0.5rem 1.8rem 1.8rem;
}

.media-system-card {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  background: var(--color-surface);
  border: 1px solid var(--color-border-soft);
  border-radius: 13px;
  box-shadow: 0 8px 24px rgba(29, 46, 35, 0.06);
  transition: border-color 150ms ease, box-shadow 150ms ease, transform 150ms ease;
}

.media-system-card:hover,
.media-system-card:focus-within {
  border-color: var(--color-accent);
  box-shadow: 0 12px 28px rgba(49, 108, 41, 0.14);
  transform: translateY(-2px);
}

.media-system-card.is-selected {
  border: 2px solid var(--color-accent);
}

.media-system-card.is-attached {
  opacity: 0.6;
}

.media-system-card.is-attached:hover,
.media-system-card.is-attached:focus-within {
  opacity: 1;
}

.media-system-flash {
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  margin: 0 1.8rem 0.5rem;
}

.media-system-flash p {
  margin: 0;
}

.media-system-card-preview {
  position: relative;
  display: grid;
  width: 100%;
  height: 155px;
  padding: 0;
  overflow: hidden;
  place-items: center;
  color: var(--color-text);
  background:
    linear-gradient(135deg, var(--color-surface-soft), var(--color-surface));
  border: 0;
  cursor: pointer;
}

.media-system-card-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.media-system-file-icon {
  display: grid;
  gap: 0.4rem;
  justify-items: center;
  color: color-mix(in srgb, var(--color-text) 70%, transparent);
}

.media-system-file-icon i {
  font-size: 3rem;
}

.media-system-file-icon.is-video,
.media-system-file-icon.is-audio {
  color: var(--color-info-text);
}

.media-system-file-icon.is-pdf {
  color: var(--color-danger-text);
}

.media-system-selected-badge {
  position: absolute;
  top: 0.55rem;
  right: 0.55rem;
  padding: 0.35rem 0.55rem;
  color: #fff;
  background: var(--color-accent);
  border-radius: 99px;
  font-size: 0.72rem;
  font-weight: 800;
}

.media-system-card-info {
  display: grid;
  gap: 0.35rem;
  padding: 0.85rem;
}

.media-system-card-info > strong,
.media-system-card-info > span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.media-system-card-info > span {
  color: color-mix(in srgb, var(--color-text) 58%, transparent);
  font-size: 0.76rem;
}

.media-system-card-actions {
  display: flex;
  gap: 0.45rem;
  margin-top: 0.35rem;
}

.media-system-status,
.media-system-empty {
  margin: 1rem 1.8rem 1.8rem;
  padding: 2.5rem;
  text-align: center;
  color: color-mix(in srgb, var(--color-text) 65%, transparent);
  background: var(--color-surface-soft);
  border-radius: 13px;
}

.media-system-empty i {
  color: var(--color-accent);
  font-size: 2.4rem;
}

.media-system-empty h3 {
  margin-bottom: 0.4rem;
  color: var(--color-text);
}

.media-system-empty p {
  margin: 0;
}

.media-system-details {
  position: fixed;
  z-index: 1100;
  top: 0;
  right: 0;
  width: min(440px, 100vw);
  height: 100vh;
  padding: 1.3rem;
  overflow-y: auto;
  background: var(--color-surface);
  border-left: 1px solid var(--color-border);
  box-shadow: -24px 0 60px rgba(0, 0, 0, 0.2);
}

.media-system-details-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.media-system-details h3 {
  margin: 0.2rem 0 1rem;
  overflow-wrap: anywhere;
}

.media-system-close {
  width: 40px;
  height: 40px;
  flex: 0 0 auto;
  color: var(--color-text);
  background: var(--color-surface-soft);
  border: 1px solid var(--color-border-soft);
  border-radius: 50%;
  cursor: pointer;
  font-size: 1.6rem;
  line-height: 1;
}

.media-system-detail-preview {
  display: grid;
  min-height: 170px;
  max-height: 360px;
  margin-bottom: 1.2rem;
  overflow: hidden;
  place-items: center;
  background: var(--color-surface-soft);
  border-radius: 12px;
}

.media-system-detail-preview img,
.media-system-detail-preview video {
  width: 100%;
  max-height: 360px;
  object-fit: contain;
}

.media-system-detail-preview audio {
  width: calc(100% - 2rem);
}

.media-system-details .group {
  margin-bottom: 1rem;
}

.media-system-detail-actions {
  margin-bottom: 1.3rem;
}

.media-system-usage {
  margin: 1.2rem 0;
  padding: 1rem;
  background: var(--color-surface-soft);
  border-radius: 10px;
}

.media-system-usage h4,
.media-system-usage p,
.media-system-usage ul {
  margin-bottom: 0.6rem;
}

.media-system-usage ul {
  padding-left: 1.2rem;
  font-size: 0.86rem;
}

.media-system-details-footer {
  align-items: center;
  justify-content: space-between;
  padding-top: 1rem;
  border-top: 1px solid var(--color-border-soft);
}

.media-system button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.media-system-modal-backdrop {
  position: fixed;
  z-index: 1000;
  inset: 0;
  display: grid;
  padding: 2rem;
  overflow-y: auto;
  place-items: center;
  background: rgba(11, 20, 15, 0.72);
  backdrop-filter: blur(5px);
}

.media-system-modal-backdrop > [role="dialog"] {
  width: min(1100px, 100%);
  max-height: calc(100vh - 4rem);
  overflow-y: auto;
  border-radius: 18px;
}

.media-system-popover {
  max-height: min(760px, 80vh);
  margin-top: 1rem;
  overflow-y: auto;
  box-shadow: 0 22px 70px rgba(29, 46, 35, 0.2);
}

.media-system-demo-picker {
  margin-top: 2rem;
  padding: 1.2rem;
  background: var(--color-surface-soft);
  border: 1px solid var(--color-border-soft);
  border-radius: 12px;
}

.media-system-demo-events {
  margin-top: 1rem;
  padding: 1rem;
  border-left: 4px solid var(--color-accent);
}

.media-system-demo-events h4,
.media-system-demo-events ul {
  margin-bottom: 0.5rem;
}

@media screen and (max-width: 700px) {
  .media-system-header {
    display: grid;
    gap: 1rem;
    padding: 1.2rem;
  }

  .media-system-header-actions .button {
    flex: 1;
  }

  .media-system-toolbar {
    grid-template-columns: 1fr;
    padding: 1rem 1.2rem;
  }

  .media-system-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.7rem;
    padding: 0.25rem 1.2rem 1.2rem;
  }

  .media-system-card-preview {
    height: 125px;
  }

  .media-system-card-actions {
    display: grid;
  }

  .media-system-modal-backdrop {
    align-items: end;
    padding: 0;
  }

  .media-system-modal-backdrop > [role="dialog"],
  .media-system-modal {
    max-height: 94vh;
    border-radius: 18px 18px 0 0;
  }
}

@media screen and (max-width: 420px) {
  .media-system-grid {
    grid-template-columns: 1fr;
  }

  .media-system-card {
    display: grid;
    grid-template-columns: 120px minmax(0, 1fr);
  }

  .media-system-card-preview {
    height: 100%;
    min-height: 130px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/Media/MediaLibraryManager.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,wBAAwB;EACxB;;wBAEsB;EACtB,0CAA0C;EAC1C,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,6BAA6B;EAC7B,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,6EAA6E;EAC7E,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mEAAmE;EACnE,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,wBAAwB;EACxB,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,6DAA6D;EAC7D,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,gCAAgC;EAChC,0CAA0C;EAC1C,mBAAmB;EACnB,6CAA6C;EAC7C,gFAAgF;AAClF;;AAEA;;EAEE,iCAAiC;EACjC,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB;4EAC0E;EAC1E,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,wBAAwB;EACxB,WAAW;EACX,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,6DAA6D;EAC7D,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,MAAM;EACN,QAAQ;EACR,wBAAwB;EACxB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,wBAAwB;EACxB,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;IACb,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,gDAAgD;IAChD,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;;IAEE,gBAAgB;IAChB,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,2CAA2C;EAC7C;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF","sourcesContent":[".media-system {\n  position: relative;\n  color: var(--color-text);\n  background:\n    radial-gradient(circle at top right, rgba(116, 187, 80, 0.12), transparent 28rem),\n    var(--color-surface);\n  border: 1px solid var(--color-border-soft);\n  border-radius: 18px;\n  box-shadow: 0 18px 50px rgba(29, 46, 35, 0.08);\n  overflow: hidden;\n}\n\n.media-system .sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.media-system-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 2rem;\n  padding: 1.6rem 1.8rem 1.3rem;\n  border-bottom: 1px solid var(--color-border-soft);\n}\n\n.media-system .media-system-header h2 {\n  margin: 0.15rem 0 0.35rem;\n  font-size: clamp(1.55rem, 2.5vw, 2.2rem);\n  line-height: 1.1;\n}\n\n.media-system-header p {\n  margin: 0;\n  color: color-mix(in srgb, var(--color-text) 68%, transparent);\n}\n\n.media-system-eyebrow {\n  display: block;\n  color: var(--color-accent);\n  font-size: 0.74rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.media-system-header-actions,\n.media-system-detail-actions,\n.media-system-details-footer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.65rem;\n}\n\n.media-system-header-actions .button,\n.media-system-detail-actions .button,\n.media-system-details-footer .button,\n.media-system-card-actions .button {\n  border-radius: 8px;\n}\n\n.media-system-header-actions .button i {\n  margin-right: 0.45rem;\n}\n\n.media-system-upload {\n  padding: 1.2rem 1.8rem;\n  background: var(--color-surface-soft);\n  border-bottom: 1px solid var(--color-border-soft);\n}\n\n.media-system-dropzone {\n  display: grid;\n  justify-items: center;\n  gap: 0.45rem;\n  padding: 1.6rem;\n  text-align: center;\n  border: 2px dashed var(--color-border);\n  border-radius: 14px;\n  transition: 160ms ease;\n}\n\n.media-system-dropzone.is-dragging {\n  border-color: var(--color-accent);\n  background: color-mix(in srgb, var(--color-accent) 10%, var(--color-surface));\n  transform: translateY(-2px);\n}\n\n.media-system-dropzone > i {\n  color: var(--color-accent);\n  font-size: 2rem;\n}\n\n.media-system-dropzone > span {\n  font-size: 0.85rem;\n  color: color-mix(in srgb, var(--color-text) 65%, transparent);\n}\n\n.media-system-dropzone input {\n  width: min(100%, 420px);\n  margin-top: 0.5rem;\n}\n\n.media-system-upload-progress {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 0.35rem 1rem;\n  align-items: center;\n  margin-top: 1rem;\n}\n\n.media-system-upload-progress span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.media-system-upload-progress progress {\n  grid-column: 1 / -1;\n  width: 100%;\n}\n\n.media-system-toolbar {\n  display: grid;\n  grid-template-columns: minmax(240px, 1fr) minmax(150px, 210px) auto;\n  gap: 0.8rem;\n  align-items: center;\n  padding: 1rem 1.8rem;\n}\n\n.media-system-toolbar input,\n.media-system-toolbar select {\n  width: 100%;\n  min-height: 42px;\n  padding: 0.65rem 0.75rem;\n  color: var(--color-text);\n  background: var(--color-surface);\n  border: 1px solid var(--color-border);\n  border-radius: 9px;\n  font: inherit;\n}\n\n.media-system-search {\n  position: relative;\n}\n\n.media-system-search i {\n  position: absolute;\n  top: 50%;\n  left: 0.8rem;\n  color: color-mix(in srgb, var(--color-text) 48%, transparent);\n  transform: translateY(-50%);\n}\n\n.media-system-search input {\n  padding-left: 2.25rem;\n}\n\n.media-system-count {\n  color: color-mix(in srgb, var(--color-text) 62%, transparent);\n  font-size: 0.85rem;\n  white-space: nowrap;\n}\n\n.media-system-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));\n  gap: 1rem;\n  padding: 0.5rem 1.8rem 1.8rem;\n}\n\n.media-system-card {\n  min-width: 0;\n  margin: 0;\n  overflow: hidden;\n  background: var(--color-surface);\n  border: 1px solid var(--color-border-soft);\n  border-radius: 13px;\n  box-shadow: 0 8px 24px rgba(29, 46, 35, 0.06);\n  transition: border-color 150ms ease, box-shadow 150ms ease, transform 150ms ease;\n}\n\n.media-system-card:hover,\n.media-system-card:focus-within {\n  border-color: var(--color-accent);\n  box-shadow: 0 12px 28px rgba(49, 108, 41, 0.14);\n  transform: translateY(-2px);\n}\n\n.media-system-card.is-selected {\n  border: 2px solid var(--color-accent);\n}\n\n.media-system-card.is-attached {\n  opacity: 0.6;\n}\n\n.media-system-card.is-attached:hover,\n.media-system-card.is-attached:focus-within {\n  opacity: 1;\n}\n\n.media-system-flash {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 1.8rem 0.5rem;\n}\n\n.media-system-flash p {\n  margin: 0;\n}\n\n.media-system-card-preview {\n  position: relative;\n  display: grid;\n  width: 100%;\n  height: 155px;\n  padding: 0;\n  overflow: hidden;\n  place-items: center;\n  color: var(--color-text);\n  background:\n    linear-gradient(135deg, var(--color-surface-soft), var(--color-surface));\n  border: 0;\n  cursor: pointer;\n}\n\n.media-system-card-preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.media-system-file-icon {\n  display: grid;\n  gap: 0.4rem;\n  justify-items: center;\n  color: color-mix(in srgb, var(--color-text) 70%, transparent);\n}\n\n.media-system-file-icon i {\n  font-size: 3rem;\n}\n\n.media-system-file-icon.is-video,\n.media-system-file-icon.is-audio {\n  color: var(--color-info-text);\n}\n\n.media-system-file-icon.is-pdf {\n  color: var(--color-danger-text);\n}\n\n.media-system-selected-badge {\n  position: absolute;\n  top: 0.55rem;\n  right: 0.55rem;\n  padding: 0.35rem 0.55rem;\n  color: #fff;\n  background: var(--color-accent);\n  border-radius: 99px;\n  font-size: 0.72rem;\n  font-weight: 800;\n}\n\n.media-system-card-info {\n  display: grid;\n  gap: 0.35rem;\n  padding: 0.85rem;\n}\n\n.media-system-card-info > strong,\n.media-system-card-info > span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.media-system-card-info > span {\n  color: color-mix(in srgb, var(--color-text) 58%, transparent);\n  font-size: 0.76rem;\n}\n\n.media-system-card-actions {\n  display: flex;\n  gap: 0.45rem;\n  margin-top: 0.35rem;\n}\n\n.media-system-status,\n.media-system-empty {\n  margin: 1rem 1.8rem 1.8rem;\n  padding: 2.5rem;\n  text-align: center;\n  color: color-mix(in srgb, var(--color-text) 65%, transparent);\n  background: var(--color-surface-soft);\n  border-radius: 13px;\n}\n\n.media-system-empty i {\n  color: var(--color-accent);\n  font-size: 2.4rem;\n}\n\n.media-system-empty h3 {\n  margin-bottom: 0.4rem;\n  color: var(--color-text);\n}\n\n.media-system-empty p {\n  margin: 0;\n}\n\n.media-system-details {\n  position: fixed;\n  z-index: 1100;\n  top: 0;\n  right: 0;\n  width: min(440px, 100vw);\n  height: 100vh;\n  padding: 1.3rem;\n  overflow-y: auto;\n  background: var(--color-surface);\n  border-left: 1px solid var(--color-border);\n  box-shadow: -24px 0 60px rgba(0, 0, 0, 0.2);\n}\n\n.media-system-details-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.media-system-details h3 {\n  margin: 0.2rem 0 1rem;\n  overflow-wrap: anywhere;\n}\n\n.media-system-close {\n  width: 40px;\n  height: 40px;\n  flex: 0 0 auto;\n  color: var(--color-text);\n  background: var(--color-surface-soft);\n  border: 1px solid var(--color-border-soft);\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 1.6rem;\n  line-height: 1;\n}\n\n.media-system-detail-preview {\n  display: grid;\n  min-height: 170px;\n  max-height: 360px;\n  margin-bottom: 1.2rem;\n  overflow: hidden;\n  place-items: center;\n  background: var(--color-surface-soft);\n  border-radius: 12px;\n}\n\n.media-system-detail-preview img,\n.media-system-detail-preview video {\n  width: 100%;\n  max-height: 360px;\n  object-fit: contain;\n}\n\n.media-system-detail-preview audio {\n  width: calc(100% - 2rem);\n}\n\n.media-system-details .group {\n  margin-bottom: 1rem;\n}\n\n.media-system-detail-actions {\n  margin-bottom: 1.3rem;\n}\n\n.media-system-usage {\n  margin: 1.2rem 0;\n  padding: 1rem;\n  background: var(--color-surface-soft);\n  border-radius: 10px;\n}\n\n.media-system-usage h4,\n.media-system-usage p,\n.media-system-usage ul {\n  margin-bottom: 0.6rem;\n}\n\n.media-system-usage ul {\n  padding-left: 1.2rem;\n  font-size: 0.86rem;\n}\n\n.media-system-details-footer {\n  align-items: center;\n  justify-content: space-between;\n  padding-top: 1rem;\n  border-top: 1px solid var(--color-border-soft);\n}\n\n.media-system button:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.media-system-modal-backdrop {\n  position: fixed;\n  z-index: 1000;\n  inset: 0;\n  display: grid;\n  padding: 2rem;\n  overflow-y: auto;\n  place-items: center;\n  background: rgba(11, 20, 15, 0.72);\n  backdrop-filter: blur(5px);\n}\n\n.media-system-modal-backdrop > [role=\"dialog\"] {\n  width: min(1100px, 100%);\n  max-height: calc(100vh - 4rem);\n  overflow-y: auto;\n  border-radius: 18px;\n}\n\n.media-system-popover {\n  max-height: min(760px, 80vh);\n  margin-top: 1rem;\n  overflow-y: auto;\n  box-shadow: 0 22px 70px rgba(29, 46, 35, 0.2);\n}\n\n.media-system-demo-picker {\n  margin-top: 2rem;\n  padding: 1.2rem;\n  background: var(--color-surface-soft);\n  border: 1px solid var(--color-border-soft);\n  border-radius: 12px;\n}\n\n.media-system-demo-events {\n  margin-top: 1rem;\n  padding: 1rem;\n  border-left: 4px solid var(--color-accent);\n}\n\n.media-system-demo-events h4,\n.media-system-demo-events ul {\n  margin-bottom: 0.5rem;\n}\n\n@media screen and (max-width: 700px) {\n  .media-system-header {\n    display: grid;\n    gap: 1rem;\n    padding: 1.2rem;\n  }\n\n  .media-system-header-actions .button {\n    flex: 1;\n  }\n\n  .media-system-toolbar {\n    grid-template-columns: 1fr;\n    padding: 1rem 1.2rem;\n  }\n\n  .media-system-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 0.7rem;\n    padding: 0.25rem 1.2rem 1.2rem;\n  }\n\n  .media-system-card-preview {\n    height: 125px;\n  }\n\n  .media-system-card-actions {\n    display: grid;\n  }\n\n  .media-system-modal-backdrop {\n    align-items: end;\n    padding: 0;\n  }\n\n  .media-system-modal-backdrop > [role=\"dialog\"],\n  .media-system-modal {\n    max-height: 94vh;\n    border-radius: 18px 18px 0 0;\n  }\n}\n\n@media screen and (max-width: 420px) {\n  .media-system-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .media-system-card {\n    display: grid;\n    grid-template-columns: 120px minmax(0, 1fr);\n  }\n\n  .media-system-card-preview {\n    height: 100%;\n    min-height: 130px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
